import React from "react";
import { server } from "../../../../../api";
import { resolveImageUrl } from "../../utils/imageUtils";
import { isIdentityView } from "../../../LiveDashboardModal/utils/viewTransform";

// The plan image TRACKS the editor's view: the zoom-1 image fills the FLOOR
// box (objectFit contain inside it, top-left, as on the live dashboard; the
// canvas may be larger than the floor) and is scaled by zoom about the canvas
// origin and shifted by pan --
// the same `px * zoom + pan` the viewport applies to every marker, so image
// and markers stay locked together at any zoom. At zoom 1 no transform is
// set at all. `view` absent = zoom 1.
const trackingStyle = (view) =>
  view && !isIdentityView(view)
    ? {
        transform: `translate(${view.pan.x}px, ${view.pan.y}px) scale(${view.zoom})`,
        transformOrigin: "0 0",
      }
    : {};

// The floor box at zoom 1: the viewport fits the floor with min(scaleX,
// scaleY) and pins metre (0, H) to pixel (0, 0). No canvasSize = the old
// full-box image.
const floorBoxSize = (dimensions, canvasSize) => {
  if (!canvasSize || !dimensions.width || !dimensions.height) {
    return { width: "100%", height: "100%" };
  }
  const scale = Math.min(
    canvasSize.width / dimensions.width,
    canvasSize.height / dimensions.height,
  );
  return { width: dimensions.width * scale, height: dimensions.height * scale };
};

// No image = nothing here: the floor paint above it draws the no-image sheet.
const CanvasImage = ({ imageUrl, dimensions, canvasSize, view, opacity = 1 }) => {
  if (!imageUrl) return null;
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        ...floorBoxSize(dimensions, canvasSize),
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        pointerEvents: "none",
        ...trackingStyle(view),
      }}
    >
      <img
        src={resolveImageUrl(imageUrl, server)}
        alt="平面圖"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          objectPosition: "top left",
          pointerEvents: "none",
          ...(opacity < 1 ? { opacity } : {}),
        }}
      />
    </div>
  );
};

export default CanvasImage;

